export enum EstadoPrecioCargado {
    Aprobado = 0,
	Cancelado = 1	
}